import React from 'react';
import {Col, Row} from 'antd';
import {SelectedItemDiv} from "./Buttons/SelectedItemDiv";

/**
 * The panels for multi row bulk actions for transactions in Table (supports View Pdf and QuickShare via Email).
 * Props:
 * - renderBulkActionButtons: Array of Functions: (selectedIds) => BulkActionButton
 * - selectedIds: Int[] of ids selected fr bulk actions
 */
export function BulkActionPanel(props) {
    const { selectedIds, renderBulkActionButtons, setSelectedIds, showZeroSelected } = props;

    const colButtons = renderBulkActionButtons.map((renderBulkActionButton, idx) => (
        // eslint-disable-next-line react/no-array-index-key
        <Col key={idx}>
            { renderBulkActionButton(selectedIds, setSelectedIds) }
        </Col>
    )) || [];

    return (
        <Row gutter={[6, 0]} align="middle">
            { colButtons || null }
            <Col>
                <SelectedItemDiv selectedIds={selectedIds} showZeroSelected={showZeroSelected} />
            </Col>
        </Row>
    );
}
